import errorSounds from './error.wav'
import successSounds from './success.mp3'

const soundsAssets = {
  error: errorSounds,
  success: successSounds,
}

export default soundsAssets
